import React from 'react';
import PropTypes from 'prop-types';

const GameProgressBar = ({
  numberOfPlayedChallenges,
  numberOfRemainingChallenges,
}) => (
  <div
    role="progressbar"
    className="games-progress-bar"
    aria-valuenow={numberOfPlayedChallenges}
    aria-valuemin="0"
    aria-valuemax={numberOfPlayedChallenges + numberOfRemainingChallenges}
    aria-valuetext={`${numberOfRemainingChallenges} Games Remaining`}
  >
    <div className="games-progress-bar-track">
      {[...Array(numberOfPlayedChallenges).keys()].map(i => (
        <span key={i} className="games-progress-bar-icon games-progress-bar-icon-complete" />
      ))}
      {[...Array(numberOfRemainingChallenges).keys()].map(i => (
        <span key={i} className="games-progress-bar-icon games-progress-bar-icon-incomplete" />
      ))}
    </div>
  </div>
);

GameProgressBar.propTypes = {
  numberOfPlayedChallenges: PropTypes.number.isRequired,
  numberOfRemainingChallenges: PropTypes.number.isRequired,
};

export default GameProgressBar;
